import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
let _ = (t)=>t, t, t1, t2;
import { keyframes } from '@emotion/react';
export const transition = ({ duration = 200, attributes = [], easing = 'ease' })=>{
    if (easing === 'wobbly') {
        easing = 'cubic-bezier(0.64, 0.57, 0.67, 1.6)';
    }
    return attributes.map((attribute)=>`${attribute} ${duration}ms ${easing}`).join(', ');
};
const fadeInKeyframe = keyframes(t || (t = _`
  0% {
    opacity: 0;
    pointer-events: none;
  }
  100% {
    opacity: 1;
  }
`));
const openInKeyframe = keyframes(t1 || (t1 = _`
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(1);
  }
`));
const openUpKeyframe = keyframes(t2 || (t2 = _`
  0% {
    transform: translateY(100%);
  }
  50% {
    transform: translateY(-1%);
  }
  100% {
    transform: translateY(0);
  }
`));
export const animate = ({ duration = 200, type, delay = 0, direction = 'normal' })=>{
    let anim;
    if (type === 'fade-in') {
        anim = fadeInKeyframe;
    }
    if (type === 'open-in') {
        anim = openInKeyframe;
    }
    if (type === 'open-up') {
        anim = openUpKeyframe;
    }
    /* duration | easing-function | delay | iteration-count | direction | fill-mode | play-state | name */ return `${duration}ms ease-in-out ${delay}ms 1 ${direction} both running ${anim}`;
};
